import React, { useRef, useState } from "react";
import { request } from "../../../functions/request";
import { Button, Descriptions, Form, Input, Select, Tooltip } from "antd";
import { updateData, verificarVariacaoValor } from "../../../functions/functionsUtility";
import { FaSave } from "react-icons/fa";
import dayjs from "dayjs";

const algodaoOptions = [
  { value: "cot_max", label: "Valor Máximo", span: 2 },
  { value: "cot_min", label: "Valor Mínimo", span: 2 },
];

const estadosOptions = [
  { value: "GO", label: "Goiás" },
  { value: "MG", label: "Minas Gerais" },
  { value: "MT", label: "Mato Grosso" },
  { value: "BA", label: "Bahia" },
  { value: "MS", label: "Mato Grosso do Sul" },
  { value: "TO", label: "Tocantins" },
  { value: "MA", label: "Maranhão" },
  { value: "SP", label: "São Paulo" },
  { value: "PI", label: "Piauí" },
];

export default function IntergraosAlgodaoCotacao() {
  const [cotacoesData, setCotacoesData] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  // Aviso de cotação fora do padrão, como em soja e milho: compara o que é
  // digitado com o valor carregado (variação acima de 10%).
  const baselineRef = useRef({});
  const [camposComAlerta, setCamposComAlerta] = useState({});

  async function getData(value) {
    setIsLoading(true);
    const response = await request(
      `/algodao_cotacao/getLastAlgodaoCotacao?uf=${value}`,
      {
        method: "GET",
      }
    );
    const data = {
      ...response,
      cot_uf: value,
      endpoint: "updateAlgodaoCotacao",
      path: "algodao_cotacao",
    };
    Object.keys(data).forEach((el) => {
      if (typeof data[el] === "number" && el !== "cot_id") {
        data[el] = data[el].toFixed(2);
        data[el] = data[el].replace(".", ",");
      }
    });
    setCotacoesData(data);
    baselineRef.current = data;
    setCamposComAlerta({});
    setIsLoading(false);
  }

  return (
    <Form>
      <Descriptions
        title={"Intergrãos - Algodão - Cotação"}
        bordered
        extra={
          <Button
            type="primary"
            size="large"
            htmlType="submit"
            icon={<FaSave />}
            disabled={isLoading}
            onClick={() => {
              updateData(cotacoesData);
            }}
          >
            Atualizar
          </Button>
        }
        style={{ padding: 10 }}
      >
        <Descriptions.Item
          label={"Estado"}
          span={3}
          children={
            <Select
              style={{ width: "100%", marginTop: "10px" }}
              onChange={(value) => {
                setCotacoesData({ ...cotacoesData, cot_uf: value });
                getData(value);
              }}
              placeholder="Selecione o estado"
            >
              {estadosOptions.map((el, index) => {
                return (
                  <Select.Option key={index} value={el.value}>
                    {el.label}
                  </Select.Option>
                );
              })}
            </Select>
          }
        />
        {!isLoading && cotacoesData?.cot_data && (
          <Descriptions.Item
            label={"Última Alteração"}
            span={3}
            children={dayjs(
              cotacoesData?.cot_data,
              "YYYY-MM-DDTHH:mm:ss.zzz"
            ).format("DD/MM/YYYY [às] HH:mm")}
          />
        )}
        {!isLoading &&
          algodaoOptions.map((element) => (
            <Descriptions.Item
              key={element.value}
              label={element.label}
              span={element.span}
              children={
                <Tooltip
                  title={camposComAlerta[element.value]?.mensagem}
                  open={!!camposComAlerta[element.value]}
                  color="orange"
                >
                  <Input
                    status={camposComAlerta[element.value] ? "warning" : ""}
                    value={cotacoesData[element.value]}
                    onChange={(event) => {
                      const inputValue = event.target.value;
                      const formattedValue = inputValue.trim();
                      const newData = {
                        ...cotacoesData,
                        [element.value]: formattedValue,
                      };
                      setCotacoesData(newData);
                    }}
                    onBlur={() => {
                      const alerta = verificarVariacaoValor(
                        cotacoesData[element.value],
                        baselineRef.current[element.value],
                        element.label
                      );
                      setCamposComAlerta((prev) => ({
                        ...prev,
                        [element.value]: alerta,
                      }));
                    }}
                  />
                </Tooltip>
              }
            />
          ))}
      </Descriptions>
    </Form>
  );
}
